export default __webpack_public_path__ + "static/media/paypal5.82fe91e0.png";